module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12"
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "color": "brown lighten-1",
      "dark": "",
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_c('h4', [_vm._v("Choisissez le repas à éditer")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-dialog', {
    ref: "dialog",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.pickerDateModal),
      callback: function($$v) {
        _vm.pickerDateModal = $$v
      },
      expression: "pickerDateModal"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "dark": ""
    },
    slot: "activator"
  }, [_vm._v(_vm._s(_vm.displayDate))]), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "locale": "fr-FR",
      "first-day-of-week": 1,
      "max": new Date().toISOString().substr(0, 10)
    },
    model: {
      value: (_vm.pickerDate),
      callback: function($$v) {
        _vm.pickerDate = $$v
      },
      expression: "pickerDate"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.pickerDateModal = false
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.changeDate(_vm.pickerDate);
        _vm.pickerDateModal = false
      }
    }
  }, [_vm._v("Choisir")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openFractionningDialog($event)
      }
    }
  }, [_vm._v("Fractionnement...")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "xs12"
  }, [_c('v-tabs', {
    attrs: {
      "grow": "",
      "dark": "",
      "color": "brown lighten-1"
    },
    model: {
      value: (_vm.currentIndex),
      callback: function($$v) {
        _vm.currentIndex = $$v
      },
      expression: "currentIndex"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "yellow"
    }
  }), _vm._v(" "), _vm._l((_vm.mealTypes), function(type, index) {
    return _c('v-tab', {
      key: index,
      attrs: {
        "router": "",
        "disabled": !_vm.isMealPresent(index)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.changeIndex(index)
        }
      }
    }, [_vm._v("\n                     " + _vm._s(_vm.mealNames[index]) + "\n                  ")])
  })], 2)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12"
  }, [_c('router-view', {
    attrs: {
      "name": "mealAssessment"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm8"
  }, [_c('router-view', {
    attrs: {
      "name": "mealElements"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "xs12 sm4"
  }, [_c('router-view', {
    attrs: {
      "name": "favorites"
    },
    on: {
      "addFavorite": _vm.addFavorite
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.fractionningDialog) ? _c('fractionning-dialog', {
    attrs: {
      "title": "Fractionnement de la journée",
      "value": _vm.editedFractionning
    },
    on: {
      "close": function($event) {
        _vm.fractionningDialog = false
      },
      "input": _vm.setFractionning,
      "cancel": _vm.cancelFractionning
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e8b470b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nutrieduc/NutriEduc.vue
// module id = 1196
// module chunks = 1